<template>
  <v-container fluid class="pa-0 grid-list-md">
    <v-row justify="center">
      <v-col cols="12" md="11" mx-auto>
        <v-card flat>
          <v-card-title class="px-0 py-2">
            <v-combobox
              v-model="curComm"
              label="Community"
              :items="commList"
              item-text="comm_name"
              item-value="comm_id"
              placeholder="Choose"
              @input="curComm ? loadFeedbackBasedOnComm(curComm) : ''"
              filled
              clearable
            ></v-combobox>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
    <v-flex xs12>
      <v-layout row wrap>
        <v-flex xs12 sm12 >
          <v-card >
            <!-- <v-card-title class="py-1 title grey lighten-4">
                Feedback and Snag Audit Action List
              </v-card-title> -->
            <v-card-text class="pa-0" >
              <v-data-table
                :headers="onbSnagAuditActionItemHeader"
                :items="snagAuditActionItemList"
                dense
                height="600px"
                :mobile-breakpoint="0">
                  <template slot="item" slot-scope="props">
                    <tr @click="disableSubmitButton || props.item.source != source_var ? '' : prepareSnagAuditActionUpdate(props.item)">
                      <td style="font-size: 12px;">{{ props.index + 1 }}</td>
                      <td style="font-size: 12px;">{{ props.item.category }}</td>
                      <td style="font-size: 12px;">{{ props.item.snag_des }}</td>
                      <td style="font-size: 12px;">{{ props.item.snag_action_des }}</td>
                      <td style="font-size: 12px;">{{ props.item.snag_priority }}</td>
                      <td style="font-size: 12px;">{{ props.item.status ? props.item.status : '-' }}</td>
                      <td style="font-size: 12px;">{{ props.item.disp_short_name ? props.item.disp_short_name.replace(/,/g, ", ") : '-' }}</td>
                      <td style="font-size: 12px;">{{ props.item.created_by ? props.item.created_by : '-' }}</td>
                      <td style="font-size: 12px;" class="text-center">{{ props.item.created_date ? handy.formatDate(props.item.created_date) : '-' }}</td>
                      <td style="font-size: 12px;" class="text-center">{{ props.item.plan_end_dt ? handy.formatDate(props.item.plan_end_dt) : '-' }}</td>
                      <td style="font-size: 12px;">{{ props.item.updated_by ? props.item.updated_by : '-' }}</td>
                      <td style="font-size: 12px;" class="text-center">{{ props.item.actual_end_dt ? handy.formatDate(props.item.actual_end_dt) : '-' }}</td>
                      <td style="font-size: 12px;">{{ props.item.source ? props.item.source : '-' }}</td>
                      <td style="font-size: 12px;">{{ props.item.remarks ? props.item.remarks : '-' }}</td>
                    </tr>
                  </template>
                </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-flex>
  </v-container>
</template>

<script>
import handy from "@/utils/handy";
import config from "@/config/app-cfg";

export default {
  data() {
    return {
      // Common Declarations
      sbarMsg: "",
      sbar: false,
      sbarCol: "error",
      handy: handy,
      config: config,
      rules: handy.rules,
      beingSaved: false,
      curComm: "",
      commList: [],
      vendorList: [],
      lAction: "",
      lCommName: "",
      onbSnagAuditActionItemHeader: [
        { text: 'SNo.', value: '', class: 'pr-0 blue lighten-2 white--text', align: 'left', width: '55px', sortable: false },
        { text: 'Category', value: 'category', class: 'blue lighten-2 white--text', width: '150px' },
        { text: 'Snag Description', value: 'snag_des', class: 'blue lighten-2 white--text', width: '200px', align: 'left', sortable: false },
        { text: 'Action Item', value: 'snag_action_des', class: 'blue lighten-2 white--text', width: '200px' },
        { text: 'Priority', value: 'snag_priority', class:'blue lighten-2 white--text', width: '100px', align: 'left', sortable: false },
        { text: 'Status', value: 'status', class:'blue lighten-2 white--text', width: '100px' },
        { text: 'Responsibility', value: 'disp_short_name', class:'blue lighten-2 white--text', width: '150px', sortable: false },
        { text: 'Created By', value: 'created_by', class:'blue lighten-2 white--text', width: '120px', sortable: false },
        { text: 'Created Date', value: 'created_date', class:'blue lighten-2 white--text', width: '120px', sortable: false },
        { text: 'Plan End Date', value: 'plan_end_dt', class:'blue lighten-2 white--text', width: '120px', align: 'center', sortable: false },
        { text: 'Updated By', value: 'updated_by', class:'blue lighten-2 white--text', width: '120px', align: 'center', sortable: false },
        { text: 'Act End Date', value: 'actual_end_dt', class:'blue lighten-2 white--text', width: '120px', align: 'center', sortable: false },
        { text: 'Source', value: 'source', class:'blue lighten-2 white--text', width: '100px' },
        { text: 'Remark', value: 'remarks', class:'blue lighten-2 white--text', width: '250px', sortable: false },
      ],
      snagAuditActionItemList: [],
    };
  },
  mounted() {
    this.loadCommunityName();
    this.lAction = "view";
    // loadResponsibiltyEmpList();
  },
  methods: {
    // Common Methods
    msg(m, type = 0) {
      if (type === 0) {
        this.sbarCol = "error";
      } else if (type === 1) {
        this.sbarCol = "success";
      } else {
        this.sbarCol = "info";
      }
      this.sbar = true;
      this.sbarMsg = m;
    },
    loadCommunityName() {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID,
        },
      }
      this.axios.get(config.API_URL + "/getListOfCommunityByVendorId/", qry)
        .then((response) => {
          this.commList = response.data;
        })
        .catch((err) => {
          this.msg(err.response.data);
        })
    },
    loadFeedbackBasedOnComm(curComm) {
      var qry = {
        params: {
          comm_id: this.curComm.comm_id,
          vendor_id: config.VENDOR_ID
        },
      }
      this.snagAuditActionItemList = [];
      this.axios.get(config.API_URL + "/getFeedbackBasedOnComm/",qry)
        .then((response) => {
          this.snagAuditActionItemList = response.data;
        })
        .catch((err) => {
          this.msg(err, true);
        });
    },
    loadResponsibiltyEmpList () {
      var qry = {
        params: {
          vendor_id: config.VENDOR_ID
        }
      }
      this.axios.get(config.API_URL + '/getMIAllResponseList/', qry)
      .then(response => {
        this.responsibilityEmpList = response.data.filter(rec =>rec.mi_status === "Active")
      })
      .catch(err => {
        this.msg(err, 0)
      })
    }
  }
}
</script>
